// key-value
export default {
    PLATFORM_INDEX: 'platform/index',
    PLATFORM_HUAFEI_SEND : 'platform/huaFei/makeOrder',
    PLATFORM_VIDEO_SEND : 'platform/video/makeOrder',
    PLATFORM_JIAYOUKA_SEND : 'platform/jiayouka/makeOrder',
    PLATFORM_GAME_SEND : 'platform/game/makeOrder',

    PLATFORM_ELEC_CARD_SEND: 'platform/electronicCard/makeOrder',

    PRODUCT_QUERY_CID: 'product/queryByCategoryId',
    QUERY_PRODUCT_RELATION_BY_PID :"product/queryProductRelation",
    QUERY_PRODUCT_RELATION_BY_CID :"product/queryProductRelationsByCid",

    ORDER_QUERY_LIST : 'order/queryList',
    ORDER_QUERY_ONE: 'order/queryDetailInfo',

    INDEX_BANNER_QUERY: 'banner/queryIndexBanners',

    EQUITY_CODE_QUERY : 'equityCode/queryCodeInfo',
    SEND_VALID : 'equityCode/sendCode',
    EQUITY_CODE_EXCHANGE : 'equityCode/exchangeEquity',

    JIUGONGGE_INIT : 'jiuGongGe/init',
    JIUGONGGE_DRAW : 'jiuGongGe/draw',
    JIUGONGGE_QUERY_MYPRIZELIST : 'jiuGongGe/queryPrizeList',

    LUCK_WHEEL_QUERY_PRODUCT_LIST : 'luckWheel/queryProductList',
    LUCK_WHEEL : 'luckWheel/luck',

    CUSTOMER_LOGIN : 'customer/login'
};


// WEBPACK FOOTER //
// ./src/api/interface.js